import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentLines } from '@fortawesome/pro-regular-svg-icons';

// utils
import { getPageScript, parseScriptTemplate } from '../../../../utils/script';
import { evaluateConditions } from '../../../../common/utils/enrollment';

function ScriptBox() {
  const { pathname = '' } = useLocation();
  const { script = [] } = useSelector(store => store.script);
  const { values: currentValues } = useSelector(store => store);
  /* eslint-disable no-unused-vars */
  const [
    empty,
    enroll,
    carrier,
    planYear,
    section,
    page,
  ] = pathname.split('/');

  const pageScript = getPageScript({ script, section, page });

  const shouldDisplay = evaluateConditions({ currentValues, conditions: pageScript.displayIf });

  let elements = [];
  if (shouldDisplay) elements = parseScriptTemplate(pageScript.blocks, currentValues);

  return (
    <div className="ps-2">
      <h4>
        Script
        <FontAwesomeIcon icon={faCommentLines} size="lg" className="ms-2" />
      </h4>
      {elements}
    </div>
  );
}

export default ScriptBox;
